<template>
  <b-sidebar
    id="sidebar-1"
    width="70vw"
    shadow
    :visible="visibility"
    @change="changeVisibility"
  >
    <div class="d-flex flex-column align-items-center justify-content-center px-3 py-2">
      <b-img
        :src="image"
        fluid
        style="width: 90vh"
        thumbnail
      />
      <b-button
        variant="outline-primary"
        class="mt-2"
        @click="visibility = false"
      >
        <feather-icon
          variant
          icon="XIcon"
        />
        Закрыть
      </b-button>
    </div>
  </b-sidebar>
</template>

<script>
import { BSidebar, BButton, BImg } from 'bootstrap-vue'

export default {
  components: {
    BSidebar,
    BButton,
    BImg,
  },
  model: {
    prop: 'visibility',
    event: 'changed',
  },
  props: {
    image: {
      type: String,
      required: true,
    },
    visibility: {
      type: null,
      required: true,
    },
  },
  methods: {
    changeVisibility(e) {
      console.log(e)
      this.$emit('changed', e)
    },
  },
}
</script>

<style>

</style>
